/**
 * Determines whether a child step is on the onComplete or onFail path
 * by inspecting the parent step's configuration.workflow
 */
function deriveEdgeType (dag, childStep) {
  if (!childStep.parentStepId) return 'default'

  const parent = dag.steps.find(s => s.dagStepId === childStep.parentStepId)
  if (!parent) return 'default'

  const workflow = parent.configuration?.workflow
  if (!workflow) return 'onComplete'

  const onFail = workflow.onFail
  if (onFail === '*' || (Array.isArray(onFail) && onFail.includes(childStep.dagStepId))) {
    return 'onFail'
  }

  const onComplete = workflow.onComplete
  if (onComplete === '*' || (Array.isArray(onComplete) && onComplete.includes(childStep.dagStepId))) {
    return 'onComplete'
  }

  return 'onComplete'
}

/**
 * Converts a Dagger DAG (with flat steps[] and parentStepId pointers)
 * into xyflow { nodes, edges } format.
 */
export function dagToGraph (dag) {
  const steps = dag.steps ?? []

  const nodes = steps.map(step => ({
    id: step.dagStepId,
    type: 'step',
    position: { x: 0, y: 0 },
    data: {
      ...step,
      dagName: dag.name
    }
  }))

  const edges = steps
    .filter(s => s.parentStepId)
    .map(s => ({
      id: `${s.parentStepId}->${s.dagStepId}`,
      source: s.parentStepId,
      target: s.dagStepId,
      type: 'workflow',
      data: { edgeType: deriveEdgeType(dag, s) }
    }))

  return { nodes, edges }
}
